module.exports = __webpack_public_path__ + "static/media/prostitutionArticle2.16839952.jpg";